
    import axios from "axios";

    const api = axios.create({
      baseURL: "https://kszogrenci.kocaeli.edu.tr/services/api",
  });

    export default api;


    //  import axios from "axios";

    //    const api = axios.create({
    //      baseURL: "http://localhost:5000/api",
    //    });
    //    export default api;
